import client from '../../client';

import type { IFileUploadStatus, IGetFileUploadStatusParams, IManualFileUploadCompleteParams } from './types';

export const aiAgentFileApis = {
  getFileUploadStatus: (data: IGetFileUploadStatusParams) =>
    client.get<IFileUploadStatus>(`/ai-agent/companies/${data.companyId}/pipeline/${data.fileUploadId}/status`),
  postCompleteFileUpload: (params: IManualFileUploadCompleteParams) =>
    client.post(`/extension/model-upload/complete/${params.fileUploadId}`, { fileSize: params.fileSize }),
};
